export class Usuario {

  id_usuario: number;
  nombre: string;
  apellidos: string;
  activo: number;
  email: string;
  telefono: string;
  id_empresa: number;
  sessionexpiretime: number;
  password: string;
  passwordre: string;
  allowip: string;
  id_role:number;

  constructor(){
    this.id_usuario = 0;
    this.nombre = "";
    this.apellidos = "";
    this.activo = 0;
    this.email = "";
    this.telefono = "";
    this.id_empresa = 0;
    this.sessionexpiretime = 0;
    this.password = "";
    this.passwordre = "";
    this.allowip = "";
    this.id_role = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/_models/usuario.model.ts